import { PlanogramComplianceResponse, PlanogramComplianceBox, RogItemStatus } from "../types";
export type LayerType = RogItemStatus.CORRECT | RogItemStatus.MOVE | RogItemStatus.OUT | RogItemStatus.REMOVE;

export const getFilteredBoxesForLayer = (
  layerKey: LayerType,
  planogramComplianceData: PlanogramComplianceResponse,
    selectedIlItemIds?: Set<number>,
): PlanogramComplianceBox[] => {
  if (!Array.isArray(planogramComplianceData.boxes))
    return [];
  return planogramComplianceData.boxes.filter((box: PlanogramComplianceBox) => {
    if (box.complianceStatus == null) return false;

    // First check if this box matches the layer type (rogItemStatus)
    const matchesLayerType = (() => {
      switch (layerKey) {
        case RogItemStatus.CORRECT:
        case RogItemStatus.MOVE:
        case RogItemStatus.OUT:
        case RogItemStatus.REMOVE:
          return box.rogItemStatus === layerKey;
        default:
          return false;
      }
    })();

    if (!matchesLayerType) return false;

    // Filter based on selection if an item is selected
    if (selectedIlItemIds && selectedIlItemIds.size > 0) {
      const selectedItemId = Array.from(selectedIlItemIds)[0];

      // Try to find the selected box by pogItemId (planogram click) or rogItemId (realogram click)
      let selectedBox = planogramComplianceData.boxes.find(
        (b: PlanogramComplianceBox) => b.pogItemId === selectedItemId
      );

      const isPlanogramClick = !!selectedBox;

      if (!selectedBox) {
        // Try finding by rogItemId (realogram click)
        selectedBox = planogramComplianceData.boxes.find(
          (b: PlanogramComplianceBox) => b.rogItemId === selectedItemId
        );
      }

      if (selectedBox) {
        if (isPlanogramClick && selectedBox.pogPositionVector) {
          // For planogram clicks, filter by position matching ONLY
          return (
            box.rogPositionVector &&
            box.rogPositionVector.position ===
              selectedBox.pogPositionVector.position &&
            box.rogPositionVector.tagName ===
              selectedBox.pogPositionVector.tagName &&
            box.rogPositionVector.shelf === selectedBox.pogPositionVector.shelf
          );
        } else {
          // For realogram clicks, show only the specific item by rogItemId
          return box.rogItemId === selectedItemId;
        }
      }

      // If no match found, hide the item
      return false;
    }

    return true;
  });
};